import { clsx } from 'clsx'

import styles from './Onboarding.module.css'

import type { JSX } from 'react'

function Progress({ currentSlide }: { currentSlide: number }): JSX.Element {
  return (
    <div className={styles.progressWrapper}>
      <div
        className={clsx(styles.progressCircle, {
          [styles.empty]: currentSlide === 1,
        })}
      />
      <div
        className={clsx(styles.progressCircle, {
          [styles.empty]: currentSlide === 2,
        })}
      />
      <div
        className={clsx(styles.progressCircle, {
          [styles.empty]: currentSlide === 3,
        })}
      />
      <div
        className={clsx(styles.progressCircle, {
          [styles.empty]: currentSlide === 4,
        })}
      />
    </div>
  )
}

export { Progress }
